const environment = process.env.REACT_APP_ENV || 'local';

const config = require(`./${environment}`);

module.exports = config;
